import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { BookOpen } from 'lucide-react';

/**
 * Shopify Flow setup walkthrough — linked from the Marketing tab's webhook card.
 * Source: /app/memory/SHOPIFY_FLOW_SETUP.md
 */
export default function ShopifyFlowSetupPage() {
  const [md, setMd] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get('/docs/shopify-flow-setup')
      .then(r => setMd(r.data.markdown || ''))
      .catch(e => setErr(e.response?.data?.detail || e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-4 sm:p-6" data-testid="shopify-flow-setup">
      <div className="flex items-center gap-2 mb-4">
        <BookOpen size={20} style={{ color: '#2A7B88' }} />
        <h1 className="text-lg sm:text-xl font-bold" style={{ color: '#1B2A4A' }}>Shopify Flow → ScaleBoard Setup</h1>
      </div>
      {loading && <p className="text-sm" style={{ color: '#9CA3AF' }}>Loading…</p>}
      {err && <p className="text-sm" style={{ color: '#D4726A' }}>{err}</p>}
      {!loading && !err && (
        <pre className="whitespace-pre-wrap text-[13px] leading-6 font-mono" style={{ color: '#1B2A4A', backgroundColor: '#FAFAF7', padding: '1rem', borderRadius: '8px', border: '1px solid #E5E1DC' }}>
          {md}
        </pre>
      )}
    </div>
  );
}
